import { alpha, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Slider from "react-slick";
import {
  CustomBoxFullWidth,
  CustomStackFullWidth,
  SliderCustom,
} from "../../styled-components/CustomStyles.style";
import CustomImageContainer from "../CustomImageContainer";
import CustomContainer from "../container";

const Banners = ({ landingPageData, isSmall }) => {
  const infiniteManage = () => {
    if (isSmall) {
      if (landingPageData?.promotion_banners?.length === 1) {
        return false;
      } else {
        return true;
      }
    } else {
      if (landingPageData?.promotion_banners?.length > 3) {
        return true;
      } else {
        return false;
      }
    }
  };
  const slidesToShowManage = () => {
    if (isSmall) {
      return 1;
    } else {
      if (landingPageData?.promotion_banners?.length > 2) {
        return 3;
      } else if (landingPageData?.promotion_banners?.length === 2) {
        return 2;
      } else {
        return 1;
      }
    }
  };
  const twoItemManage = () => {
    return (
      <CustomStackFullWidth flexDirection="row" gap="20px">
        {/* <Grid container spacing={2}> */}
        {landingPageData?.promotion_banners?.map((item, index) => {
          return (
            // <Grid
            // 	key={index}
            // 	item
            // 	sm={6}
            // 	md={6}
            // 	// align={index === 0 ? "right" : "left"}
            // >
            <Box
              key={`banner-${item?.img || item?.id || index}`}
              sx={{
                border: (theme) =>
                  `0.828571px solid ${alpha(theme.palette.primary.main, 0.15)}`,
                backgroundColor: (theme) => theme.palette.background.paper,
                position: "relative",
                height: "175px",
                width: { sm: "100%", md: "395px" },
                borderRadius: "5px",
                overflow: "hidden",
                "&:hover": {
                  img: {
                    transform: "scale(1.1)",
                    transition: "transform .8s ease-in-out",
                  },
                },
              }}
            >
              <CustomImageContainer
                src={`${landingPageData?.base_urls?.promotional_banner_url}/${item.img}`}
                alt="banners"
                height="100%"
                width="100%"
                objectfit="contain"
                borderRadius="5px"
              />
            </Box>
            // </Grid>
          );
        })}
        {/* </Grid> */}
      </CustomStackFullWidth>
    );
  };
  const sliderManage = () => {
    const theme = useTheme();
    return (
      <SliderCustom
        sx={{
          backgroundColor: "transparent",
          "& .slick-slider": {
            backgroundColor: "transparent",
            "& .slick-list": {
              backgroundColor: "transparent",
              "& .slick-track": {
                backgroundColor: "transparent",
              },
            },
            "& .slick-slide": {
              padding: { xs: "5px", md: "11px" },
              "& > div": {
                backgroundColor: "transparent",
              },
            },
            "& .slick-arrow": {
              backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.8 : 0.9),
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              zIndex: 1,
              "&:before": {
                color: theme.palette.mode === 'dark' 
                  ? theme.palette.text.primary
                  : theme.palette.text.primary,
                fontSize: "20px",
              },
              "&:hover": {
              backgroundColor: theme.palette.mode === 'dark' 
                ? alpha(theme.palette.background.paper, 0.95)
                : theme.palette.background.paper,
              },
            },
          },
        }}
      >
        <Slider {...settings}>
          {landingPageData?.promotion_banners?.map((item, index) => {
            return (
              <Box
                key={`slider-banner-${item?.img || item?.id || index}`}
                sx={{
                  border: (theme) =>
                    `0.828571px solid ${alpha(
                      theme.palette.primary.main,
                      0.15
                    )}`,
                  backgroundColor: (theme) => theme.palette.background.paper,
                  position: "relative",
                  height: "175px",
                  width: "100%",
                  borderRadius: "5px",
                  overflow: "hidden",
                  "&:hover": {
                    img: {
                      transform: "scale(1.1)",
                      transition: "transform 0.8s ease-in-out",
                    },
                  },
                }}
              >
                <CustomImageContainer
                  src={`${landingPageData?.base_urls?.promotional_banner_url}/${item?.img}`}
                  alt="banners"
                  height="100%"
                  width="100%"
                  objectfit="contain"
                  borderRadius="5px"
                />
              </Box>
            );
          })}
        </Slider>
      </SliderCustom>
    );
  };
  const settings = {
    dots: false,
    infinite: infiniteManage(),
    slidesToShow: slidesToShowManage(),
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const singleImageManage = () => {
    return (
      <CustomBoxFullWidth
        sx={{
          display: "flex",
          alignItems: "center",
          // justifyContent: "center",
        }}
      >
        <Box
          sx={{
            border: (theme) =>
              `0.828571px solid ${alpha(theme.palette.primary.main, 0.15)}`,
            backgroundColor: (theme) => theme.palette.background.paper,
            position: "relative",
            height: "175px",
            // width: { xs: "100%", sm: "90%" },
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <CustomImageContainer
            src={`${landingPageData?.base_urls?.promotional_banner_url}/${landingPageData?.promotion_banners[0]?.img}`}
            alt="banners"
            height="100%"
            width="100%"
            objectfit="contain"
            borderRadius="5px"
          />
        </Box>
      </CustomBoxFullWidth>
    );
  };
  const handleContent = () => {
    if (isSmall) {
      if (landingPageData?.promotion_banners?.length === 1) {
        return <>{singleImageManage()}</>;
      } else {
        return <>{sliderManage()}</>;
      }
    } else {
      if (landingPageData?.promotion_banners?.length === 1) {
        return <>{singleImageManage()}</>;
      } else if (landingPageData?.promotion_banners?.length === 2) {
        return <>{twoItemManage()}</>;
      } else {
        return <>{sliderManage()}</>;
      }
    }
  };
  const theme = useTheme();
  return (
    <CustomContainer>
      <CustomStackFullWidth 
        sx={{ 
          marginY: isSmall ? "22px" : "40px",
          backgroundColor: "transparent",
          "& .slick-slider": {
            backgroundColor: "transparent",
            "& .slick-list": {
              backgroundColor: "transparent",
              "& .slick-track": {
                backgroundColor: "transparent",
              },
            },
            "& .slick-slide": {
              "& > div": {
                backgroundColor: "transparent",
              },
            },
          },
        }}
      >
        {handleContent()}
      </CustomStackFullWidth>
    </CustomContainer>
  );
};

export default Banners;
